import { gql } from '@apollo/client';

export const GET_DRIVE_INTEGRATION_URL = gql`
  query get_drive_integration_url($data: GetDriveIntegrationURLInputType) {
    get_drive_integration_url(data: $data) {
        hasError
        data
        message
    }
}
`;

export const GET_GOOGLEDRIVE_TOKEN = gql`
 mutation get_googleDrive_token($data: GetGoogleDrivesTokenInputType) {
    get_googleDrive_token(data: $data) {
        hasError
        data
        message
    }
}
`;


export const GET_INTEGRATIONS = gql`
  query get_integrations($data: GetIntegrationsInputType) {
      get_integrations(data: $data) {
          hasError
          data
          message
      }
}
`;

export const GET_INTEGRATIONS_BY_TYPE = gql`
  query get_integrations_by_type($data: GetIntegrationsByTypeInputType!) {
    get_integrations_by_type(data: $data) {
      hasError
      message
      data
    }
  }
`;

export const ADD_GOOGLE_CALENDAR_INTEGRATION = gql`
  mutation add_google_calendar_integration($data: AddGoogleCalendarIntegrationInputType) {
    add_google_calendar_integration(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const GET_GOOGLE_CALENDAR_INTEGRATION = gql`
  query get_google_calendar_integration($data: GetGoogleCalendarIntegrationInputType) {
    get_google_calendar_integration(data: $data) {
      hasError
      data
      message
    }
  }
`;

export const UPDATE_CHANNEL_SETTINGS = gql`
  mutation update_channel_settings($data: UpdateChannelSettingsInputType!) {
    update_channel_settings(data: $data) {
      hasError
      message
      data
    }
  }
`;
